// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2cbTT","info":"Note_info__2pCVH","note":"Note_note__32g82","actions":"Note_actions__1ECxd"};